export const STATUS_COLORS = {
  draft: { label: 'Draft', paletteKey: 'info' },
  discarded: { label: 'Discarded', paletteKey: 'error' },
  clientPassed: { label: 'Client passed/missed', paletteKey: 'error' },
  awaiting: { label: 'Sent to client', paletteKey: 'info' },
  inquireInterest: { label: 'Sent for client insight/interest', paletteKey: 'info' },
  interviewOpportunity: { label: 'Interview opportunity', paletteKey: 'info' },
  clientNeedsEdits: { label: 'Needs edits', paletteKey: 'purple' },
  needsFollowUp: { label: 'Needs follow up', paletteKey: 'purple' },
  clientApproved: { label: 'Client approved', paletteKey: 'success' },
  pending: { label: 'Submitted to journalist', paletteKey: 'purple' },
  successful: { label: 'Successful placement', paletteKey: 'success' },
  repurposed: { label: 'Repurpose', paletteKey: 'brown' },
  pendingPublication: { label: 'Pending publication', paletteKey: 'neutral' },
  paidEditorial: { label: 'Paid editorial', paletteKey: 'success' },
  journalistPassed: { label: 'Journalist passed', paletteKey: 'error' },
  insightsNotIncluded: { label: 'Insights not included', paletteKey: 'warning' },
};

const EXTERNAL_STATUS_ALIAS = {
  'submitted to journalist': 'pending',
  'coordinating next steps': 'pending',
  'pending publication': 'pendingPublication',
  'successful placement': 'successful',
  'client passed': 'clientPassed',
  'journalist passed': 'journalistPassed',
  'insights not included': 'insightsNotIncluded',
  'paid editorial': 'paidEditorial',
  repurpose: 'repurposed',
};

export const getStatusColor = (status) => {
  if (!status) return null;
  return STATUS_COLORS[status] || STATUS_COLORS[EXTERNAL_STATUS_ALIAS[status?.toLowerCase()]] || null;
};
